<svelte:options customElement={{
  tag: "keyvisual-content",
  shadow: "none",
  props: {
    title: { type: "String" },
    image: { type: "String" },
    single: { type: "String" },
    usp: { type: "String" }, // BooleanよりStringで受ける方が確実
    usparray: { type: "String" } // JSON文字列として受け取る
  }
}} />

<script>
  let {
    title = "",
    spacing = "true",
    image = "",
    single = "false",
    usp = "false",
    usparray = "",
    usprow = ""
  } = $props();

  // --- 判定ロジック ---

  // 1. USPを表示するかどうかの判定 (文字列 "true" もしくは booleanの true を許容)
  const isUspActive = $derived(usp === "true" || usp === true);
  const isSingleActive = $derived(single === "true" || single === true);
  const isSpacingActive = $derived(spacing === "true" || spacing === true);
  const kvClass = $derived(
    (title && image) ? "owd-keyvisual" : "owd-keyvisual:single"
  );

  // 2. usparrayのパース (文字列で来た場合はJSON.parse、オブジェクトならそのまま)
  const data = $derived.by(() => {
    if (!usparray) return { first: [], second: [], third: []};
    if (typeof usparray === 'string') {
      try {
        return JSON.parse(usparray);
      } catch (e) {
        console.error("usparray parse error:", e);
        return { first: [], second: [], third: []};
      }
    }
    return usparray;
  });
</script>

<!-- 表示部分 -->
<section class={isSingleActive ? null : (isUspActive ? "spacing:bottom:40" : "spacing:bottom:16")}>
<div class={kvClass}>
  {#if title}
  <h2 class={isSpacingActive ? "owd-heading:02 align:center spacing:bottom:32 owd-keyvisual-title" : "owd-heading:02 align:center owd-keyvisual-title"}>
    {@html title}
  </h2>
  {/if}
  {#if image}
  <img src={image} width="344" height="211" alt="キービジュアル">
  {/if}
</div>

{#if isUspActive}
<div class={`${isUspActive ? "owd-usp-wrap" : ""} ${isUspActive && usprow ? "row" : ""}`.trim()}>
  <!-- 1段目のリスト -->
  {#if data.first && data.first.length > 0}
    <ul class="owd-usp">
      {#each data.first as item}
        <li class="owd-usp-listitem">
          <img class="owd-usp-listitem-icon" src="/assets_default/icons/usp/{item.icon}.svg" alt="">
          <p class="owd-text:02"><strong>{@html item.label}</strong></p>
        </li>
      {/each}
    </ul>
  {/if}

  <!-- 2段目のリスト -->
  {#if data.second && data.second.length > 0}
    <ul class="owd-usp">
      {#each data.second as item}
        <li class="owd-usp-listitem">
          <img class="owd-usp-listitem-icon" src="/assets_default/icons/usp/{item.icon}.svg" alt="">
          <p class="owd-text:02"><strong>{@html item.label}</strong></p>
        </li>
      {/each}
    </ul>
  {/if}
  <!-- 3段目のリスト -->
  {#if data.third && data.third.length > 0}
    <ul class="owd-usp">
      {#each data.third as item}
        <li class="owd-usp-listitem">
          <img class="owd-usp-listitem-icon" src="/assets_default/icons/usp/{item.icon}.svg" alt="">
          <p class="owd-text:02"><strong>{@html item.label}</strong></p>
        </li>
      {/each}
    </ul>
  {/if}
  </div>
{/if}
</section>

<style lang="scss">
  .owd-keyvisual-title {
    font-weight: 600;
  }

  .row {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    .owd-usp {
      width: auto;
      display: inline-flex;
    }
  }
</style>
